/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free PCR master mix calculator. Scale each reagent to any number of reactions with pipetting overage, and get the total master mix volume to prepare.`)
};

const es_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de master mix para PCR gratuita. Escala cada reactivo a cualquier número de reacciones con exceso de pipeteo, y obtén el volumen total de master mix a preparar.`)
};

const de_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser PCR-Mastermix-Rechner. Skalieren Sie jedes Reagenz mit Pipettierüberschuss auf beliebig viele Reaktionen und erhalten Sie das Gesamtvolumen des anzusetzenden Mastermixes.`)
};

const nl_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis PCR-mastermixcalculator. Schaal elk reagens naar elk aantal reacties met pipetteeroverschot en bereken het totale mastermixvolume dat u moet klaarmaken.`)
};

const fr_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de mix maître PCR gratuit. Adaptez chaque réactif à n'importe quel nombre de réactions avec une marge de pipetage, et obtenez le volume total de mix maître à préparer.`)
};

const it_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito del master mix PCR. Scala ogni reagente per qualsiasi numero di reazioni con margine di sicurezza per il pipettaggio e ottieni il volume totale di master mix da preparare.`)
};

const pt_br2_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de master mix de PCR. Dimensione cada reagente para qualquer número de reações com excedente para perdas de pipetagem e obtenha o volume total de master mix a preparar.`)
};

const pt_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de master mix de PCR gratuita. Escale cada reagente para qualquer número de reações com excedente de pipetagem e obtenha o volume total de master mix a preparar.`)
};

const ja_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のPCRマスターミックス計算機です。各試薬をピペッティング分の余剰を含めて任意の反応数にスケーリングし、調製すべきマスターミックスの総量を求めます。`)
};

const zh_pcr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 PCR 混合液计算器。将每种试剂按反应数量并加上移液损耗余量进行放大，得到需配制的混合液总体积。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_meta_description", locale)
	if (locale === "en") return en_pcr_meta_description(inputs)
	if (locale === "es") return es_pcr_meta_description(inputs)
	if (locale === "de") return de_pcr_meta_description(inputs)
	if (locale === "nl") return nl_pcr_meta_description(inputs)
	if (locale === "fr") return fr_pcr_meta_description(inputs)
	if (locale === "it") return it_pcr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_meta_description(inputs)
	if (locale === "pt") return pt_pcr_meta_description(inputs)
	if (locale === "ja") return ja_pcr_meta_description(inputs)
	return zh_pcr_meta_description(inputs)
};